const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || '';

export default class ApiHelper {

    constructor() {

        this.api_path = API_ENDPOINT.replace(/\/$/, '');

    }

    request(method, endpoint, payload = {}) {

        const url = this.api_path + endpoint;

        const init = {
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            method,
            mode: 'cors'
        };

        if (method !== 'GET' && payload && Object.keys(payload).length)
            init.body = JSON.stringify(payload);

        return new Promise((resolve, reject) => {

            fetch(url, init)
                .then(async response => {

                    const text = await response.text();

                    let body;
                    try {

                        body = text ? JSON.parse(text) : {};

                    } catch (_) {

                        // The server returned something that isn't JSON (often
                        // an HTML 502/504 from a dev proxy timeout, or an
                        // unhandled-error page from Express). Surface a
                        // useful message instead of the raw SyntaxError.
                        const snippet = text.replace(/\s+/g, ' ').slice(0, 120);
                        return reject({
                            err: `Server returned a non-JSON response (HTTP ${response.status})${snippet ? `: ${snippet}` : ''}. The request may have timed out before completing.`
                        });

                    }

                    body = body && typeof body === 'object' ? body : {};
                    const success = body.hasOwnProperty('success') ? Boolean(body.success) : false;
                    const message = typeof body.message === 'string' ? body.message : '';
                    const data = body.hasOwnProperty('data') ? body.data : null;

                    if (success)
                        resolve(data);
                    else
                        reject({ data, err: message || `HTTP ${response.status}` });

                })
                .catch(err => {

                    // If we already rejected with a structured object above,
                    // re-throw it unchanged; otherwise wrap the raw error.
                    if (err && typeof err === 'object' && 'err' in err) reject(err);
                    else reject({ err: 'Unknown error: ' + err });

                });

        });

    }

    get(endpoint) {

        return this.request('GET', endpoint);

    }

    post(endpoint, payload) {

        return this.request('POST', endpoint, payload);

    }

}
